import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  GetJobBoardResponse,
  ExtendedGreenhouseJobBoardJob,
  PodGroup,
  CreateGreenhouseJobRequest,
  UpdateGreenhouseJobRequest,
  ExtendedGreenhouseJobPost,
} from '@scale/shared-types';
import { useQuery } from 'react-query';

export function useJobBoardJobPostsQuery(podsToExclude: PodGroup[] = []) {
  return useQuery<GetJobBoardResponse>(
    [`job-board-fetch-jobs`, podsToExclude],
    async () => {
      const response = await apiFetch<GetJobBoardResponse>(
        null,
        'internal/experts/job-board/jobs',
        {
          method: 'POST',
          body: { podsToExclude },
        },
      );

      return response;
    },
    {
      refetchOnWindowFocus: false,
    },
  );
}

export const useAllGreenhouseJobPostsQuery = () =>
  useQuery<ExtendedGreenhouseJobPost[]>(
    'greenhouseJobPosts',
    () => apiFetch(null, `internal/experts/job-board/job-posts`, { method: 'GET' }),
    {
      refetchOnWindowFocus: false,
    },
  );

export function useJobBoardJobPostQuery(jobId: string, anonymousId?: string) {
  return useQuery<ExtendedGreenhouseJobBoardJob>(
    [`job-post-description`, jobId, anonymousId],
    () =>
      apiFetch(
        null,
        `internal/experts/job-board/jobs/${jobId}${
          anonymousId ? `?anonymousId=${anonymousId}` : ''
        }`,
        {
          method: 'GET',
        },
      ),
    {
      refetchOnWindowFocus: false,
    },
  );
}

export function useGreenhouseJobPostQuery(jobPostId?: string) {
  return useQuery(
    [`greenhouse-job-post`, jobPostId],
    () =>
      apiFetch(null, `corp-api/job-post/greenhouse/${jobPostId}`, {
        method: 'GET',
      }),
    {
      enabled: !!jobPostId,
      refetchOnWindowFocus: false,
    },
  );
}

export function createGreenhouseJobPost(request: CreateGreenhouseJobRequest) {
  return apiFetch(null, 'corp-api/job-post/greenhouse/', {
    method: 'POST',
    body: request,
  });
}

export function updateGreenhouseJobPost(request: UpdateGreenhouseJobRequest) {
  return apiFetch(null, `corp-api/job-post/greenhouse/${request.jobPostId}`, {
    method: 'PUT',
    body: request,
  });
}
